export default "__VITE_ASSET__4c7ffe8c__"